import moment from 'moment';
const CONSTANT = {
    LANGLOCALE_EN: [
        'en-BE',
        'en-CA',
        'en-AU'
    ],
    EMAIL_VALUES: ['network.lilly.com', 'lilly.com'],
    TERMS_LINK: 'https://collab.lilly.com/sites/GCOS/Master%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FGCOS%2FMaster%20Documents%2FEnterprise%20Customer%20Search%20Terms%20and%20Conditions%2Epdf&parent=%2Fsites%2FGCOS%2FMaster%20Documents',
    APP_ROLE: ['Commercial'],
    ADVANCE_SEARCH_MAP_KEY: ['Source'],
    ADDRESS_NAMES: ['Address', 'EditAddress'],
    LILLY_SOURCES_NEW_HCP: 'MNGD-AFF',
    EDITABLE_SOURCES: ['Lilly Managed', 'Lilly Mngd', 'MNGD-AFF', 'VNDR-CGDM'],
    ALL_SOURCES: ['MNGD-AFF', 'Lilly Managed', 'Lilly Mngd', 'VNDR-CGDM', "BRAZIL", "MIDAS", "MNGD-CN", "MNGD-EPH", "MNGD-GAM", "MNGD-MX", "MNGD-SIRI", 'LLY-MNGD',"VNDR-VOD"],
    LILLY_SOURCES_VALUES: { 
        "MNGD-AFF": "MNGD-AFF", 
        "Lilly Managed": "MNGD-OD", 
        "Lilly Mngd": "MNGD-GAM", 
        "VNDR-CGDM": "VNDR-CGDM", 
        "IQVIA": "VNDR-CGDM",
        "MNGD-CN": "MNGD-AFF" , 
        "MNGD-EPH": "MNGD-AFF" , 
        "MNGD-GAM": "MNGD-AFF", 
        "MNGD-MX": "MNGD-AFF" , 
        "MNGD-SIRI" : "MNGD-AFF",
        "LLY-MNGD": "MNGD-AFF",
        "VNDR-VOD": "VNDR-VOD"
    
    },
    LILLY_SOURCES_FOR_EDIT_PROFILE:['MNGD-AFF', 'Lilly Managed', 'Lilly Mngd', "MNGD-CN", "MNGD-EPH", "MNGD-GAM", "MNGD-MX", "MNGD-SIRI"],
    VENDOR_SOURCE:['VNDR-CGDM', 'VEEVA NETWORK', 'VNDR-VN'],
    GLOBAL: 'global',
    UNITED_STATES: 'United States',
    ES_COUNT: 760,
    NOT_AN_ARRAY: ['Sources'],
    LOV_BOUNDED_OPTION_SPCIAL_CASE: ['OtherSpecialty', 'PrimarySpecialty', 'Prefix', 'Title', 'ClassificationCode', 'SubClassificationCode', 'Type', 'SubType', 'StateProvince', 'Gender'],
    LOV_BOUNDED_OPTION: ['OtherSpecialty', 'PrimarySpecialty', 'Prefix', 'Title', 'ClassificationCode', 'SubClassificationCode', 'Type', 'SubType','Gender' ],
    TRACK_REQUEST_DATE_TIME: ['createdTime', 'updatedTime'],
    COMMERCIAL_USER: 'COMMERCIAL_USER',
    EDITABLE_ATTRIBUTE: ['FirstName', 'LastName'],
    STASTIC_ATTRIBUTE:['First Name', 'Middle Name', 'Last Name', 'Email', 'Phone', 'Address Line1', 'City', 'Zip', 'State Province','Secondary Last Name', 'Address Line 1', 'City', 'Zip', 'State Province','Full Name','Preferred Language'],
    STASTIC_ATTRIBUTE_HCO:['Name', 'Email', 'Phone', 'Address Line 1', 'City', 'Zip', 'State Province', 'Brick Id', 'Brick Effective End Date'],
    STASTIC_ATTRIBUTE_HCO_exclusion:['Name', 'Email', 'Phone', 'Address Line 1', 'City', 'Zip'],
    STATE: ['Pending', 'Approved', 'Rejected', 'PARTIALLY APPLIED','PENDING', 'APPROVED', 'REJECTED', 'APPLIED','PARTIALLY_APPLIED', 'Applied', 'Requested', 'REQUESTED'],
    EDITABLE_ATTRIBUTE_HCO: ['Name', 'ClassificationCode'],
    DCR_STATES: ['Requested','REQUESTED', 'Approved','APPROVED','Applied','APPLIED', 'Rejected', 'REJECTED', 'Awaited', 'AWAITED', 'Awaited', 'Available', 'AVAILABLE','Pending', 'PENDING', 'Partially Approved'],
    VIEW_OPTIONS: [{ key: 'Viewing', value: 'Viewing' }, { key: 'Edit', value: 'Edit' }],
    VIEW_OPTIONS_LLY_VERIFIED_VIEW_OPTION: [{ key: 'Viewing', value: 'Viewing' }],
    VIEW_OPTIONS_LLY_VERIFIED: [{ key: 'Viewing', value: 'Viewing' }, { key: 'Mark as Lilly Verified', value: 'Mark as Lilly Verified' }],
    VIEW_OPTIONS_LLY_VERIFIED_EDIT: [{ key: 'Viewing', value: 'Viewing' }, { key: 'Mark as Lilly Verified', value: 'Mark as Lilly Verified' }, { key: 'Mark as Lilly Verified and Edit', value: 'Mark as Lilly Verified and Edit' }],

    ADD_NEW_ATTRIBUTE: ['Specialities', 'Specialty', 'Relation', 'NewSpecialities', 'AddAddress','Identifiers','NewIdentifiers','Phone','NewPhone', 'Email', 'NewEmail', 'First Name', 'Middle Name', 'Last Name', 'Classification Code'],

    HCO: "https://s3.amazonaws.com/reltio.images/api/images/defaultImage/no-org.png",
    HCP: "https://dev.reltio.com/services/images?def=https%3A%2F%2Fs3.amazonaws.com%2Freltio.images%2Fapi%2Fimages%2FdefaultImage%2Fno-photo.png",
    OPTIONAL: ['Prefix', 'MiddleName', 'PrimarySpecialty', 'OtherSpecialty', 'SubClassificationCode','SecondaryLastName','PreferredLanguage'],
    MERGE_STATE: ['Approve', 'Pending', 'Rejected'],
    DCR_ACTIONED_STATE: ['APPROVED','REJECTED', 'Rejected', 'Approved', 'APPLIED', 'Applied'],
    REQUIRED: ['First Name', 'Last Name', 'Full Name', 'Classification Code', 'Active Flag'],
    REQUIRED_HCP: ['First Name', 'Last Name', 'Classification Code', 'Primary Specialty', 'Country Code', 'Country', 'Address Line1', 'Address Line 1', 'City', 'Zip', 'State Province', 'Rank','Phone', 'Primary Specialty'],
    REQUIRED_HCP_ID: ['FirstName', 'LastName', 'ClassificationCode', 'PrimarySpecialty', 'Relation', 'CountryCode', 'Address','Phone'],
    SHOW_VALUE_NUMBER: 6,
    SHOW_VALUE_INCREMENT: 4,
    HCP_RELATION: ['US', 'United States'],
    RESTRICT_COUNTRY: ['MX','Mexico','CO','Colombia'],
    SPECIALITY_TYPE: ['PrimarySpecialty', 'OtherSpecialty'],
    IDENTIFIERS_TYPE: ['Type', 'Id','SubType'],
    ADDRESS_ATTRIBUTE: ['AddressLine1', 'City', 'Zip', 'StateProvince', 'Country', 'Rank', 'ActiveFlag', 'BRICK'],
    EMP_ADDRESS_ATTRIBUTE: ['AddressLine1', 'AddressLine1', 'City', 'Zip', 'StateProvince', 'Country', 'Rank', 'ActiveFlag'],
    ADD_ADDRESS_ATTRIBUTE: ['AddressLine1', 'City', 'Zip', 'StateProvince', 'Country', 'Rank', 'BRICK'],
    BRICK_FIELDS: {
        BRICK_TYPE: 'Type',
        BRICK_ID: 'ID',
        BRICK_EFFECTIVE_START_DATE: 'EffectiveStartDate',
        BRICK_EFFECTIVE_END_DATE: 'EffectiveEndDate',
        BRICK_SOURCE: 'Source',
    },
    BRICK_LILLY_MANAGED_SOURCES: ['MNGD-EPH', 'MNGD-AFF', 'MNGD-GAM', 'MNGD-OD', 'LLY-MNGD'],
    STRICT_ATTRIBUE: ['Name', 'FirstName', 'LastName', 'TranslatedName', 'Address.AddressLine'],
    Relation_Attribute: ['HCO', 'Country', 'AddressLine1', 'City', 'Zip', 'StateProvinceCode'],
    HCO_ADDRESS_EDITABLE_EPH: ['Address Line1', 'City', 'State Province','Zip','Country', 'Active Flag', 'Zip', 'Zip5'],
    HCO_ADDRESS_EDITABLE_VENDOR: ['Address Line1', 'City', 'State Province','Country','Zip','Rank',  'Active Flag', 'Zip5'],
    HCP_IDENTIFIER_DEACTIVATION_EDIT_FIELD:['Status'],
    NEW_HCP_BODY: {
        entity: {
            type: "configuration/entityTypes/HCP",
            ActiveFlag: [{ value: 'Y' }],
            EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
            EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: undefined,NewIdentifiers: [] , Address: undefined, Source: [{ value: "MNGD-AFF" }]
        }, relations: []
    },
    NEW_EMP_HCP_BODY: {
        entity: {
            type: "configuration/entityTypes/HCP",
            ActiveFlag: [{ value: 'Y' }],
            EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
            EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: undefined, NewIdentifiers: [] , Address: undefined, Source: [{ value: "Employer" }]
        }, relations: []
    },
    NEW_HCP_IQVIA_BODY: {
        entity: {
            type: "configuration/entityTypes/HCP",
            ActiveFlag: [{ value: 'Y' }],
            EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
            EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: undefined,NewIdentifiers: undefined , Address: undefined, Source: [{ value: "MNGD-AFF" }]
        }, relations: [], RequestTo: "IQVIA", vendor: "IQVIA"
  },
    ROLE_MAPPER: { "ecs_admin": 'ADMIN', "ecs_commercial": "COMMERCIAL USER" },
    ACCESS_TYPE: ["revoke", "accept", "reject", "add"],
    FORCED_OPTION: ['Active Flag', 'Rank', 'Status'],
    OPERATION_ROLE: ['manager', 'admin'],
    FORCED_OPTION_VALUE: { 'Active Flag': ['Y', 'N'], 'Rank': ['1', '99'], 'Status':['Active', 'Inactive'] },
    TYPE_AHEAD_NUMBER_HCO: 15,
    TYPE_HEAD_COUNT_GLOBAL: 10,
    DISABLE_ADD_ADDRESS_HCP: false,
    CONSENTS_ATTEMPTS : 2,
    IQVIA_HCP_IDENTIFIER_COUNT: 2,
    IQVIA_HCO_IDENTIFIER_COUNT: 1,
    NEW_HCO_BODY: {
        entity: {
            type: "configuration/entityTypes/HCO",
            ActiveFlag: [{ value: 'Y' }],
            EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
            EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: undefined,NewIdentifiers: [] , Address: [], Source: [{ value: "MNGD-AFF" }]
        }, relations: []
    },
    NEW_EMP_HCO_BODY: {
        entity: {
            type: "configuration/entityTypes/HCO",
            ActiveFlag: [{ value: 'Y' }],
            EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
            EffectiveEndDate: [{ value: "9999-12-31" }], NewIdentifiers: [] , Address: [], Source: [{ value: "Employer" }]
        }, relations: []
    },
    NEW_HCO_IQVIA_BODY: {
        entity: {
            type: "configuration/entityTypes/HCO",
            ActiveFlag: [{ value: 'Y' }],
            EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
            EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: undefined,NewIdentifiers: undefined , Address: [], Source: [{ value: "MNGD-AFF" }]
        }, relations: [], RequestTo: "IQVIA", vendor: "IQVIA"
  },
  SHELL_PROFILE_VALIDATION_REASON_CODE: ['Vendor Profile Never Received', 'Vendor Rejected' ,'Unverified' ],
}


export default CONSTANT;